const loading = new Map<string, Promise<void>>();

export function loadScript(src: string): Promise<void> {
    const pending = loading.get(src);
    if (pending) return pending;

    const promise = new Promise<void>((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            // Forget the failure so a later call can retry.
            loading.delete(src);
            script.remove();
            reject(new Error(`Could not load ${src}`));
        };
        document.head.appendChild(script);
    });

    loading.set(src, promise);
    return promise;
}
